import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { HP2, SERVICE_CARDS, SERVICE_ROUTES } from './assets';

export const ServiceShowcase = () => {
  const gridRef = useRef(null);

  useEffect(() => {
    const cards = gridRef.current?.querySelectorAll('.service-presentation') ?? [];
    if (!('IntersectionObserver' in window)) { cards.forEach((c) => c.classList.add('reveal')); return undefined; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('reveal'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    cards.forEach((c) => io.observe(c));
    return () => io.disconnect();
  }, []);

  return (
    <section className="service-showcase" id="services" aria-labelledby="services-heading" data-testid="services-section">
      <div className="service-intro">
        <h2 id="services-heading"><span className="our-services-word">OUR</span> SERVICES</h2>
        <span className="service-total">01 — 04</span>
      </div>
      <div className="service-grid" ref={gridRef}>
        {SERVICE_CARDS.map((s, i) => (
          <Link
            key={s.key}
            className="service-presentation"
            to={SERVICE_ROUTES[s.key]}
            data-service-key={s.key}
            style={{ '--service-order': i }}
            data-testid={`service-card-${s.key}`}
          >
            <img className="service-photo" src={HP2.services[s.key]} alt="" aria-hidden="true" loading="lazy" />
            <div className="service-topline">
              <span className="service-index">{`0${i + 1}`}</span>
              <span className="service-direction" aria-hidden="true">↗</span>
            </div>
            <h3>{s.name}</h3>
            <p className="service-summary">{s.summary}</p>
            <div className="service-bottomline">
              <span>{`EXPLORE ${s.name.toUpperCase()}`}</span>
              <span aria-hidden="true">→</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
